/* eslint-disable */
import React, { useState } from 'react';

const Contact = () => {
  const [reason, setReason] = useState('Contact professionel');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [mail, setMail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  return (
    <>
      <div className="w-full flex  items-center justify-center ">
        <div className="w-10/12 xl:w-7/12 bg-white gradiant-dark rounded-2xl h-5/6 mt-10 py-8 shadow-2xl mb-5">
          <form className="grid grid-cols-1 h-full  w-11/12 md:w-8/12 mx-auto">
            <h1 className="text-center text-lg text-dark_blue font-medium">
              Contact @Bob_le_bricoleur
            </h1>
            <label className="h-2 mt-3 mb-3 text-dark_blue " htmlFor="nom">
              Firstname :
            </label>
            <input
              id="nom"
              type="nom"
              name="nom"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              className="p-2 bg-light_grey border-2 border-gray-200 rounded-lg"
            />
            <label className="h-2 mt-3 mb-3 text-dark_blue " htmlFor="prenom">
              Lastname:
            </label>
            <input
              id="prenom"
              type="prenom"
              name="prenom"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              className="p-2 bg-light_grey border-2 border-gray-200 rounded-lg"
            />
            <label
              className="h-2 mt-3 mb-3 text-dark_blue border-"
              htmlFor="email"
            >
              E-mail :
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
              className="p-2 bg-light_grey border-2 border-gray-200 rounded-lg"
            />
            <label
              className="h-2 mt-3 mb-3 text-dark_blue border-"
              htmlFor="message"
            >
              Write your message:
            </label>
            <textarea
              id="message"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className=" p-2 h-36 bg-light_grey border-2 border-gray-200 rounded-lg"
            />

            <a
              href={`mailto:kevin.mrs2020@gmail.com?subject=${reason}&body=${firstname} ${lastname.toUpperCase()}%0A${mail}%0A${phone}%0A%0A${message}`}
              className="text-center"
            >
              <div className="mt-5">
                <button type="button" className="button text-base">
                  Submit
                </button>
              </div>
            </a>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
